var _g, _path, _path2, _path3, _path4, _line, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnfurnishedSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_9389_79039)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2401 15.3613C10.6927 15.3613 11.1268 15.5411 11.4469 15.8612C11.7669 16.1812 11.9467 16.6153 11.9467 17.068V18.7746H20.4799V17.068C20.4799 16.6153 20.6597 16.1812 20.9797 15.8612C21.2998 15.5411 21.7339 15.3613 22.1865 15.3613C22.6391 15.3613 23.0732 15.5411 23.3933 15.8612C23.7133 16.1812 23.8931 16.6153 23.8931 17.068V20.4812C23.8931 20.9339 23.7133 21.3679 23.3933 21.688C23.0732 22.0081 22.6391 22.1879 22.1865 22.1879H10.2401C9.78745 22.1879 9.35336 22.0081 9.03331 21.688C8.71325 21.3679 8.53345 20.9339 8.53345 20.4812V17.068C8.53345 16.6153 8.71325 16.1812 9.03331 15.8612C9.35336 15.5411 9.78745 15.3613 10.2401 15.3613V15.3613Z",
    stroke: "#5F6787",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2397 15.3597V11.0932C10.2397 10.4142 10.5095 9.76308 10.9895 9.283C11.4696 8.80291 12.1208 8.5332 12.7997 8.5332H19.6262C20.3052 8.5332 20.9563 8.80291 21.4364 9.283C21.9165 9.76308 22.1862 10.4142 22.1862 11.0932V15.3597",
    stroke: "#5F6787",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0933 22.1875V23.8941",
    stroke: "#5F6787",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 22.1875V23.8941",
    stroke: "#5F6787",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9389_79039",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 25,
    height: 25
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 28.087,
    y1: 4.61918,
    x2: 4.62029,
    y2: 28.0858,
    stroke: "#5F6787"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9389_79039)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_9389_79039)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.000244141,
    y: -0.00195312,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#5F6787"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_9389_79039",
    x: -17.662,
    y: -17.662,
    width: 67.324,
    height: 67.324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9389_79039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_9389_79039",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_9389_79039",
    x: -17.6618,
    y: -17.664,
    width: 67.324,
    height: 67.324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9389_79039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_9389_79039",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfurnishedSmall);
export default __webpack_public_path__ + "static/media/unfurnishedSmall.763f8275ec0ac3c8b56fbe0b4a2dde8c.svg";
export { ForwardRef as ReactComponent };